import { useEffect } from "react";
import '../Volunteer_step_form.css'
import { Button, Form } from "react-bootstrap";
import Select from 'react-select'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useFormContext, Controller } from "react-hook-form";
import Light_Black_Btn from "../../../common/common_btn/light_black_btn/Light_Black_Btn";
import Common_Back_Header from "../../../common/common_components/common_back_header/Common_Back_Header";
import { useDispatch } from "react-redux";
import { StepOne } from "../../../../features/admin/volunteerStepform/Slice";
import classNames from "classnames";

const Step_one = ({ nextStep, prevStep, heading }) => {

    const dispatch = useDispatch();

    const {
        register,
        handleSubmit,
        control,
        setValue,
        getValues,
        formState: { errors },
    } = useFormContext();



    console.log("getValues :", getValues());


    const onSubmit = async (values) => {
        try {
            const sendData = new FormData();


            sendData.append("f_name", values?.f_name || "");
            sendData.append("l_name", values?.l_name || "");
            sendData.append("email", values?.email || "");
            sendData.append("contact_no", values?.contact_no || "");


            sendData.append("volunteering_id", values?.volunteering_id || "");


            if (values?.volunteer_id) {
                sendData.append("volunteer_id", values.volunteer_id);
            }


            const response = await dispatch(StepOne(sendData));
            console.log("responseresponseresponse", response)

            if (response?.payload?.data?.volunteer_id) {
                setValue("volunteer_id", response.payload?.data?.volunteer_id);
            }
            if (response?.payload?.data?.message) {
                localStorage.setItem("volunteer_id", response?.payload?.data?.volunteer_id);
                nextStep();
            }



        } catch (error) {
            console.error("StepOne Submit Error:", error);
        }
    };


    useEffect(() => {
        const savedVolunteerId = localStorage.getItem("volunteer_id");

        if (savedVolunteerId) {
            setValue("volunteer_id", savedVolunteerId);
        }
    }, []);



    return (
        <>
            <div className='form_sec'>
                <div className='row'>
                    <div className='col-lg-9 mx-auto'>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Common_Back_Header backNavigation={-1} />
                            <div className='row'>
                                <div className='col-md-6 mb-3'>
                                    <div className='form-group'>
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter First Name"
                                            // {...register("f_name", { required: "First Name is required" })}
                                            {...register("f_name", {
                                                required: "First Name is required",
                                                minLength: {
                                                    value: 3,
                                                    message: "Name must be at least 3 characters",
                                                },
                                                maxLength: {
                                                    value: 50,
                                                    message: "Name cannot exceed 50 characters",
                                                },
                                                pattern: {
                                                    value: /^[A-Za-z\s]+$/,
                                                    message: "Name can contain only letters and spaces",
                                                },
                                                validate: (value) =>
                                                    value.trim().length > 0 || "Name cannot be empty spaces",
                                            })}
                                            isInvalid={!!errors.f_name}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.f_name?.message}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='form-group'>
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Last Name"
                                            // {...register("l_name", { required: "Last Name is required" })}
                                            {...register("l_name", {
                                                required: "Last Name is required",
                                                minLength: {
                                                    value: 3,
                                                    message: "Name must be at least 3 characters",
                                                },
                                                maxLength: {
                                                    value: 50,
                                                    message: "Name cannot exceed 50 characters",
                                                },
                                                pattern: {
                                                    value: /^[A-Za-z\s]+$/,
                                                    message: "Name can contain only letters and spaces",
                                                },
                                                validate: (value) =>
                                                    value.trim().length > 0 || "Name cannot be empty spaces",
                                            })}
                                            isInvalid={!!errors.l_name}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.l_name?.message}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='form-group'>
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Email"
                                            {...register("email", {
                                                required: "Email is required",
                                                pattern: {
                                                    value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                                                    message: "Enter a valid email address",
                                                }
                                            })}
                                            isInvalid={!!errors.email}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email?.message}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='form-group'>
                                        <Form.Label>Phone Number</Form.Label>
                                        <Form.Control
                                            placeholder="Contact Number"
                                            type="text"
                                            name="contact_no"
                                            maxLength={10} // restrict typing to 10 digits
                                            {...register("contact_no", {
                                                required: "Contact Number is required",
                                                pattern: {
                                                    value: /^[0-9]+$/, // only numbers
                                                    message: "Only digits are allowed",
                                                },
                                                minLength: {
                                                    value: 10,
                                                    message: "Contact Number must be exactly 10 digits",
                                                },
                                                maxLength: {
                                                    value: 10,
                                                    message: "Contact Number must be exactly 10 digits",
                                                },
                                            })}
                                        />
                                        {errors.contact_no && (
                                            <div className="invalid-feedback d-block">
                                                {errors.contact_no.message}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className='col-md-12 mt-4'>
                                    <Light_Black_Btn
                                        btnText="Next"
                                        type="submit"
                                        onClick={handleSubmit(onSubmit)}
                                    />


                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Step_one;

















// import { useState, useEffect } from "react";
// import '../Volunteer_step_form.css'
// import { Button, Form } from "react-bootstrap";
// import Select from 'react-select'
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import { useForm, Controller } from "react-hook-form";
// import Light_Black_Btn from "../../../common/common_btn/light_black_btn/Light_Black_Btn";
// import Common_Back_Header from "../../../common/common_components/common_back_header/Common_Back_Header";

// const Step_one = ({ prevStep, nextStep , props }) => {

//     const {
//         control,
//         reset,
//         register,
//         handleSubmit,
//         formState: { errors },
//     } = useForm();


//     return (
//         <>
//             <div className='form_sec'>
//                 <div className='row'>
//                     <div className='col-lg-9 mx-auto'>
//                         <Form>
//                             <Common_Back_Header backNavigation={-1} />
//                             <div className='row'>
//                                 <div className='col-md-6 mb-3'>
//                                     <div className='form-group'>
//                                         <Form.Label>First Name</Form.Label>
//                                         <Form.Control type="text" placeholder="Enter First Name" />
//                                     </div>
//                                 </div>
//                                 <div className='col-md-6 mb-3'>
//                                     <div className='form-group'>
//                                         <Form.Label>Last Name</Form.Label>
//                                         <Form.Control type="text" placeholder="Enter Last Name" />
//                                     </div>
//                                 </div>
//                                 <div className='col-md-6 mb-3'>
//                                     <div className='form-group'>
//                                         <Form.Label>Email</Form.Label>
//                                         <Form.Control type="text" placeholder="Enter Email" />
//                                     </div>
//                                 </div>
//                                 <div className='col-md-6 mb-3'>
//                                     <div className='form-group'>
//                                         <Form.Label>Phone Number</Form.Label>
//                                         <Controller
//                                             name="number"
//                                             control={control}
//                                             defaultValue=""
//                                             placeholder="Enter Mobile Number"
//                                             rules={{
//                                                 required: "Mobile number is required",
//                                                 pattern: {
//                                                     value: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{4})[-. )]*(\d{4})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
//                                                     message: "Number must be 10 digit",
//                                                 },
//                                             }}
//                                             render={({ field: { onChange, value } }) => (
//                                                 <PhoneInput
//                                                     country={"in"}
//                                                     value={"919822956771"}
//                                                     placeholder="Enter Mobile Number"
//                                                     onChange={onChange}
//                                                     inputProps={{
//                                                         name: "number",
//                                                         required: true,
//                                                         autoFocus: true,
//                                                     }}
//                                                 />
//                                             )}
//                                         />

//                                     </div>
//                                 </div>
//                                 <div className='col-md-12 mt-4'>
//                                     <Light_Black_Btn btnText={'Next'} onClick={nextStep} />
//                                 </div>

//                             </div>
//                         </Form>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default Step_one
